<template>
  <div class="wt-breadcrumb" :style="sidebar.opened ? '' : 'left: 60px;'">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          v-for="(item, index) in breadResults"
          :key="index"
        >{{ item.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="wt-breadcrumb-page-title" v-if="breadResults.length > 0">{{breadResults[breadResults.length - 1].meta.title}}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'WtBreadcrumb',
  data() {
    return {

    }
  },
  mounted() {
    this.setBreadData(this.$route)
  },
  watch: {
    $route(val) {
      this.setBreadData(val)
      return false
    }
  },
  computed: {
    ...mapState({
      breadResults: state => state.wtBreadcrumb.breads
    }),
    ...mapGetters([
      'sidebar'
    ])
  },
  methods: {
    setBreadData(val) {
      const routeSplit = val.path.split('/')
      routeSplit.shift()
      if (routeSplit.length > 0 && routeSplit[0] === 'system') {
        const parentPath = routeSplit[1]
        const leafPath = routeSplit[2]
        const bread = []
        for (const key in this.$store.state.auth.moduleMap) {
          for (const item of this.$store.state.auth.moduleMap[key]) {
            if (item.path === parentPath) {
              bread.push(item)
              break
            }
          }
        }
        for (const key in this.$store.state.auth.moduleMap) {
          for (const item of this.$store.state.auth.moduleMap[key]) {
            if (item.path === leafPath && item.meta.title === val.meta.title) {
              bread.push(item)
              break
            }
          }
        }
        this.$store.dispatch('setBreadcrumb', bread)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wt-breadcrumb {
  background-color: #FFFFFF;
  color: #666666;
  height: 100px;
  padding: 20px 80px 20px 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 60px;
  right: 0;
  z-index: 996;
  left: 220px;
  margin: 0;
  .wt-breadcrumb-page-title {
    padding-top: 20px;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
  }
}
</style>
<style lang="scss">
.wt-breadcrumb {
  .el-breadcrumb__item {
    font-size: 14px;
    .el-breadcrumb__inner {
      color: #999999;
    }
    & + .el-breadcrumb__item {
      .el-breadcrumb__inner {
        color: #666666;
      }
    }
  }
}
</style>
